import { BranchType, PartRequestService } from 'api-new/generated';
import { formatErrorMessage, QueryError } from 'features/shared/model';
import { useQuery, UseQueryOptions } from 'react-query';
import { toast } from 'react-toastify';

export const PartRequestsPartsLookupQueryKey = 'PartRequestsPartsLookupQueryKey';
export const PartRequestsPartsCheckOnStockQueryKey = 'PartRequestsPartsCheckOnStockQueryKey';

const fetchPartRequestsPartsLookup = async (brandCode?: string, partNumber?: string, branch?: BranchType) => {
  try {
    return await PartRequestService.getPartRequestsPartsLookup(brandCode, partNumber, branch);
  } catch (error) {
    const message = formatErrorMessage(error as QueryError);
    toast.error(message);
    console.error(message);
    throw error;
  }
};

export const usePartRequestsPartsLookupQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  filter: { brandCode?: string; partNumber?: string; branch?: BranchType },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof PartRequestService.getPartRequestsPartsLookup>>,
      QueryError,
      Awaited<ReturnType<typeof PartRequestService.getPartRequestsPartsLookup>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [PartRequestsPartsLookupQueryKey, ...(queryKey ?? [{ ...filter }])],
    () => fetchPartRequestsPartsLookup(filter.brandCode, filter.partNumber, filter.branch),
    options
  );
